import { PageContent, Box, Header, Heading, Button, Paragraph, Image, Form, FormField, TextInput, RadioButtonGroup, CheckBoxGroup, TextArea } from "grommet";
import { PropsWithChildren } from "react";
import { AppPage } from "../components/app-page";
import React from "react";
import UnderLadder from "../images/under-ladder.png";
import { PopUp } from "../components/popup";
import { useNavigate } from "react-router-dom";

const Rsvp: React.FC<PropsWithChildren> = () => {
    const [showPopup, setShowPopup] = React.useState(false);
    const [value, setValue] = React.useState({} as { [key: string]: any });
    const [errorMessage, setErrorMessage] = React.useState('');
    const navigate = useNavigate();

    const handleSubmit = (value: any) => {
        fetch(process.env.REACT_APP_API_BASE_URL! + "/api",
            {
                method: 'POST',
                body: JSON.stringify(value),
                headers: new Headers({ "Access-Control-Allow-Origin": "*", "Content-Type": "application/json" })
            }).then(() => {
                setShowPopup(true);
            }).catch(() => {
                setErrorMessage('There was an error submitting your RSVP. Please contact Purnam.');
            });
    };

    return (
        <AppPage>
            <>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'green_constant' }}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "large" }}>
                        <Header direction="column" className="title">
                            <Heading weight="normal" color="orange">RS<Image
                                src={UnderLadder}
                                style={{ height: "70%", transform: "scale(-1,-1)" }}
                                alignSelf="center"
                                margin="xsmall"
                            />P</Heading>
                        </Header>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'cream_constant' }} pad="small">
                    <Box align="center" pad="medium">
                        <Form
                            value={value}
                            onChange={nextValue => {
                                setValue(nextValue);
                            }}
                            onReset={() => setValue({} as { [key: string]: any })}
                            onSubmit={({ value }) => { handleSubmit(value); }}
                            style={{ width: "100%", maxWidth: "465px" }}
                        >
                            <FormField name="firstName" htmlFor="first-name" label="First Name" required>
                                <TextInput id="first-name" name="firstName" defaultValue="" plain={false} />
                            </FormField>
                            <FormField name="lastName" htmlFor="last-name" label="Last Name" required >
                                <TextInput id="last-name" name="lastName" plain={false} />
                            </FormField>
                            <FormField name="attending" htmlFor="attending" label="Are you attending?" required>
                                <RadioButtonGroup
                                    id="attending"
                                    name="attending"
                                    options={['Yes', 'No']}
                                />
                            </FormField>


                            {value["attending"] !== "No" && <>
                                <FormField name="partyMembers" htmlFor="partyMembers" label="Are there any other adults or children in your party?">
                                    <TextArea
                                        id={"partyMembers"}
                                        name="partyMembers"
                                        placeholder="Who is in your group?"
                                        plain={false}
                                    />
                                </FormField><FormField name="days" htmlFor="days" label="What days will you be there?" required >
                                    <CheckBoxGroup id="days" name="days" options={["Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]} defaultValue={[]} />
                                </FormField>
                                <FormField name="camp" htmlFor="camp" label="Are you planning to stay in the camp?" required>
                                    <RadioButtonGroup
                                        id="camp"
                                        name="camp"
                                        options={['Yes', 'No']}
                                    />
                                </FormField>
                                <FormField name="workCrew" htmlFor="days" label="Would you like to sign up for a task team?" >
                                    <CheckBoxGroup id="workCrew" name="workCrew" options={["Cooking", "Cleaning"]} defaultValue={[]} />
                                </FormField>
                                <FormField name="dietaryRestrictions" htmlFor="dietary-restrictions" label="Do you have any dietary restrictions?">
                                    <TextArea
                                        id="dietary-restrictions"
                                        name="dietaryRestrictions"
                                        plain={false}
                                    />
                                </FormField>
                                <FormField name="email" htmlFor="email" label="What is your email?" required >
                                    <TextInput id="email" name="email" plain={false} />
                                </FormField></>
                            }
                            <Box direction="row" gap="medium" pad={{ "vertical": "large" }}>
                                <Button type="submit" label="Submit" />
                            </Box>
                            {errorMessage && <Paragraph color="red">{errorMessage}</Paragraph>}
                        </Form>

                    </Box>

                    {showPopup && <PopUp title="Thank you!" description="Your RSVP has been submitted" buttonText="OK" onButtonClick={() => navigate("/")} setShow={setShowPopup} />}

                </PageContent>
            </>
        </AppPage>
    );
}

export default Rsvp;
